"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterControls = FooterControls;
exports.FooterControlsContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _marketSelector = require("./market-selector");
var _currencySelector = require("./currency-selector");
var _logoLink = _interopRequireDefault(require("./logo-link"));
var _selectors = require("./selectors");
var _footerSocialMedia = require("./footer-social-media");
var _index = _interopRequireDefault(require("../other/menu/index.js"));
var _menuItem = _interopRequireDefault(require("../other/menu/menu-item.js"));
var _index2 = _interopRequireDefault(require("../header/site-search/index.js"));
const FooterControlsContainer = exports.FooterControlsContainer = /*#__PURE__*/(0, _react2.styled)("section")({
  name: "FooterControlsContainer",
  class: "pl-f1b2gk8"
});

/**
 * Footer Controls component.
 *
 * @param {Object} props React props
 * @param {string} props.marketHeader Market Selector Header
 * @param {string} props.marketAriaLabel Market Selector Aria label
 * @param {string} props.currencyAriaLabel currency Aria label
 * @param {array} props.marketList Market List options
 * @param {Object} props.selectedMarket Current Market
 * @param {array} props.currencyList Currency List options
 * @param {Object} props.selectedCurrency Current currency
 * @param {array} props.primaryCurrencies Currency List options
 * @param {Object} props.socialMediaMenu Social Menu which contains menuItems key with the array of social media
 * @param {Boolean} props.selectorsVisible Visibility control for market and currency selectors
 * @param {String} props.setCurrencyUrl Url to set the currency when clicking
 * @param {String} props.pcgoUrl pcgoUrl
 * @param {Object} props.siteSearch options for siteSearch component
 * @param {Number} props.privateLabelId privateLabelId
 * @param {String} props.logo object containing mobileImage and desktopImage
 * @returns {React.ReactElement} Footer Legal layout
 * @public
 */
function FooterControls({
  id,
  marketHeader,
  marketAriaLabel,
  currencyAriaLabel,
  marketList,
  selectedMarket,
  currencyList,
  selectedCurrency,
  primaryCurrencies,
  socialMediaMenu,
  selectorsVisible,
  setCurrencyUrl,
  logoAriaLabel,
  pcgoUrl,
  siteSearch,
  privateLabelId,
  logoImage
}) {
  return /*#__PURE__*/_react.default.createElement(FooterControlsContainer, {
    id: `id-${id}`,
    "data-cy": "footer-controls"
  }, /*#__PURE__*/_react.default.createElement(_logoLink.default, {
    key: "logolink",
    privateLabelId: privateLabelId,
    ariaLabel: logoAriaLabel,
    logoImage: logoImage
  }), selectorsVisible && (marketList || currencyList) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("hr", {
    key: "hr"
  }), /*#__PURE__*/_react.default.createElement(_selectors.Selectors, {
    key: "selectors"
  }, marketList && /*#__PURE__*/_react.default.createElement(_marketSelector.MarketSelector, {
    key: "marketSelector",
    id: "marketSelector",
    header: marketHeader,
    ariaLabel: marketAriaLabel,
    marketList: marketList,
    selectedMarket: selectedMarket,
    pcgoUrl: pcgoUrl
  }), currencyList && /*#__PURE__*/_react.default.createElement(_currencySelector.CurrencySelector, {
    key: "currencySelector",
    id: "currencySelector",
    setCurrencyUrl: setCurrencyUrl || 'https://gui.dev-godaddy.com/preference/currency/set',
    ariaLabel: currencyAriaLabel,
    currencyList: currencyList,
    selectedCurrency: selectedCurrency,
    primaryCurrencyList: primaryCurrencies
  }), siteSearch && /*#__PURE__*/_react.default.createElement(_index2.default, siteSearch))), socialMediaMenu?.menuItems && /*#__PURE__*/_react.default.createElement(_footerSocialMedia.SocialMedia, {
    key: "socialmedia"
  }, /*#__PURE__*/_react.default.createElement(_index.default, null, socialMediaMenu.menuItems.map(socialMediaItem => /*#__PURE__*/_react.default.createElement(_menuItem.default, {
    key: socialMediaItem.icon,
    link: socialMediaItem.href,
    icon: socialMediaItem.icon,
    ariaLabel: socialMediaItem.ariaLabel,
    target: socialMediaItem.target
  })))));
}
FooterControls.propTypes = {
  id: _propTypes.default.string,
  marketHeader: _propTypes.default.string,
  marketAriaLabel: _propTypes.default.string,
  currencyAriaLabel: _propTypes.default.string,
  marketList: _propTypes.default.array,
  selectedMarket: _propTypes.default.object,
  currencyList: _propTypes.default.array,
  selectedCurrency: _propTypes.default.object,
  primaryCurrencies: _propTypes.default.array,
  socialMediaMenu: _propTypes.default.object,
  selectorsVisible: _propTypes.default.bool,
  setCurrencyUrl: _propTypes.default.string,
  companyName: _propTypes.default.string,
  logoAriaLabel: _propTypes.default.string,
  pcgoUrl: _propTypes.default.string,
  siteSearch: _propTypes.default.object,
  privateLabelId: _propTypes.default.number,
  logoImage: _propTypes.default.shape({
    height: _propTypes.default.number,
    width: _propTypes.default.number,
    altText: _propTypes.default.string,
    url: _propTypes.default.string
  })
};